import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getBranchCollection, BranchCollectionModel } from "@tCentro/Services/CENAdminBranchService";
import { BrandsCollectionModel, getBrandsCollection } from "@tCentro/Services/CENAdminBrandsService";

export interface GetBrandsCollectionParameter extends HasOnSuccess<BrandsCollectionModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
}

type HandlerType = ApiHandler<GetBrandsCollectionParameter, { apiResult: BrandsCollectionModel }>;

export const GetBrandsCollection: HandlerType = async props => {
    try {
const result = await getBrandsCollection(props.parameter.page, props.parameter.pageSize);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load branches");
        }
    }
};

export const chain = [GetBrandsCollection];
const getBrandsCollectionData = createHandlerChainRunner(chain, "getBrandsCollectionData");
export default getBrandsCollectionData;
